export const METRICS = {
    impressions:'Показы', 
    impressionsToViewsConversion: 'Конверсия из показов в просмотры',
    views: 'Просмотры',
    averageViewCost:'Средняя цена просмотра',
    viewsToContactsConversion:'Конверсия из просмотров в контакты',
    clickPackages:'Целевые просмотры',
    contacts: 'Контакты',
        // contactsMessenger:'Написали в чат',
        // contactsShowPhone:'Посмотрели телефон',
        // contactsShowPhoneAndMessenger:'телефон и чат',           <----МЕТРИКИ В СОСТАВЕ
        // contactsSbcDiscount: 'Откликнулись на скидку в чате',

    contactsMessenger:'Написали в чат',
    contactsShowPhone:'Посмотрели телефон',
    contactsShowPhoneAndMessenger:'телефон и чат',
    contactsSbcDiscount: 'Откликнулись на скидку в чате',
    averageContactCost:'Средняя цена контакта', 
    favorites:'Добавили в избранное',

    spending: 'Расходы на объявление',
        // restSpending:'Остальные расходы',
        // presenceSpending:'Расходы на размещение',         <----МЕТРИКИ В СОСТАВЕ
        // promoSpending:'Расходы на продвижение',

    spendingBonus:'Списано бонусов на объявления',
          // presenceSpendingV2:'Расходы на размещение и целевые действия',
          // presenceSpendingBonus:'Списано бонусов на размещение и целевые действия',     <----МЕТРИКИ В СОСТАВЕ
          // promoSpendingBonus: 'Списано бонусов на продвижение',
          // restSpendingBonus: 'Списано бонусов на остальные услуги',
    

    presenceSpendingV2:'Расходы на размещение и целевые действия',
    presenceSpendingBonus:'Списано бонусов на размещение и целевые действия', 
    promoSpending:'Расходы на продвижение',
    promoSpendingBonus: 'Списано бонусов на продвижение',
    restSpending:'Остальные расходы',
    restSpendingBonus: 'Списано бонусов на остальные услуги',

    allSpending:'Все расходы', //совокупность всех расходов Spending, "restSpendingBonus","promoSpendingBonus","presenceSpendingV2","restSpending","promoSpending","presenceSpendingBonus",

    activeItems: 'Активные объявления',
    newActiveItems: 'Новые и опубликованные заново',
    oldActiveItems: 'Активны с прошлого периода',

    // viewsToOrderedItemsConversion:'Конверсия из просмотров в заказанные',
    
  
  };
  
  export const METRIC_SLUGS = {
    impressions:'impressions', 
    impressionsToViewsConversion: 'impressionsToViewsConversion',
    views: 'views',
    averageViewCost:'averageViewCost',
    viewsToContactsConversion:'viewsToContactsConversion',
    clickPackages:'clickPackages',
    contacts: 'contacts',
    contactsMessenger:'contactsMessenger',
    contactsShowPhone:'contactsShowPhone',
    contactsShowPhoneAndMessenger:'contactsShowPhoneAndMessenger',
    contactsSbcDiscount: 'contactsSbcDiscount',
    averageContactCost:'averageContactCost', 
    favorites:'favorites',

    spending: 'spending',
    restSpending:'restSpending',
    presenceSpending:'presenceSpending',
    promoSpending:'promoSpending',

    presenceSpendingV2:'presenceSpendingV2',
    spendingBonus:'spendingBonus',
    presenceSpendingBonus:'presenceSpendingBonus',
    promoSpendingBonus: 'promoSpendingBonus',
    restSpendingBonus: 'restSpendingBonus',

    allSpending:'allSpending',

    activeItems: 'activeItems',
    newActiveItems: 'newActiveItems',
    oldActiveItems: 'oldActiveItems',
  };

  // export const METRIC_SLUGS = {
  //   views: 'views',
  //   contacts: 'contacts',
  //   spending: 'spending',
  //   contactsShowPhone: 'contactsShowPhone',
  //   contactsMessenger:'contactsMessenger',
  //   contactsShowPhoneAndMessenger:'contactsShowPhoneAndMessenger',
  //   favorites:'favorites',
  //   averageViewCost:'averageViewCost',
  //   averageContactCost:'averageContactCost', 
  //   clickPackages:'clickPackages',
  //   viewsToContactsConversion:'viewsToContactsConversion',
  //   viewsToOrderedItemsConversion:'viewsToOrderedItemsConversion', 
  //   impressions:'impressions',  
  //   presenceSpending:'presenceSpending',
  //   promoSpending:'promoSpending',
  //   restSpending:'restSpending', 
  //   spendingBonus:'spendingBonus',
  // };
  
  export const COLORS = {
    views: '#45C1FF', //цвет как в авито
    impressions:'#45C1FF', //цвет как в авито
    contacts: ['#00aaff'], //цвет как в авито
    clickPackages:'#3b82f6',
    viewsToContactsConversion:['#7c3aed', '#a78bfa'],
    viewsToOrderedItemsConversion:['#7c3aed', '#a78bfa'],
    contactsShowPhone:['#7c3aed', '#a78bfa'],
    contactsMessenger: ['#B184F8'], //цвет как в авито
    contactsShowPhoneAndMessenger:['#FF8CAF'], //цвет как в авито
    favorites:['#7c3aed', '#a78bfa'],
    costs: ['#10b981', '#22d3ee'],
    averageViewCost:['#10b981', '#22d3ee'],
    averageContactCost:['#10b981', '#22d3ee'], 
    presenceSpending:['#10b981', '#22d3ee'],
    promoSpending:['#10b981', '#22d3ee'],
    restSpending:['#10b981', '#22d3ee'], 
    spendingBonus:['#10b981', '#22d3ee'],
    spending:['#45C1FF'], //цвет как в авито
    allSpending:['#45C1FF'], //цвет как в авито
    activeItems:['#45C1FF'],
    newActiveItems:['#45C1FF'],
    oldActiveItems:['#45C1FF'],
    promoSpendingBonus:['#B1FCA7'], //цвет как в авито
    impressionsToViewsConversion:['#45C1FF'], //цвет как в авито



  };
  
  export const AVERAGE_METRICS = {
    averageViewCost:'averageViewCost',
    averageContactCost:'averageContactCost', 
  };


  export const RUBLE_METRIC = {
    costs: 'spending',
    averageViewCost:'averageViewCost',
    averageContactCost:'averageContactCost', 
    presenceSpending:'presenceSpending',
    promoSpending:'promoSpending',
    restSpending:'restSpending', 
    allSpending: 'allSpending',
  };

  export const BONUS_METRIC = {
    spendingBonus:'spendingBonus',
    promoSpendingBonus: 'promoSpendingBonus',
  };


  export const PERCENT_METRICS = {
    viewsToContactsConversion:'viewsToContactsConversion',
    impressionsToViewsConversion: 'impressionsToViewsConversion',
  };

  